import NeighborhoodPage from "@/components/NeighborhoodPage";

const Flamengo = () => (
  <NeighborhoodPage
    name="Flamengo"
    slug="flamengo"
    description="Bairro tradicional da Zona Sul do Rio, com o maior parque urbano da cidade, orla ampla e edifícios clássicos de excelente arquitetura e vista para a Baía de Guanabara."
  />
);

export default Flamengo;
